e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
        if ( jQuery('.js-eldorado-video-modal').length > 0 ){
            e4.product.video.init();
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );

        jQuery( '.js-e-productlist' ).on( 'loaded.e4.jsonpublisher', function ( event ) {
            eldorado.ecom.matrix.init();
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
        jQuery( '.js-e-product-images' ).find( '.js-e-jsonpublisher' ).on( 'load.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).addClass( 'is-loading' );
        } ).on( 'loaded.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).removeClass( 'is-loading' );
        } );

        jQuery('.js-eldorado-partial-add-to-cart').on('click', '.js-eldorado-ordermatrix-btn', function(event){
            var jProductItem = jQuery(event.target).closest('.js-e-product');
            eldorado.ecom.getVariantMatrix(jProductItem);
        });
    },
    video: {
        vimeo: {
            iframes: [],
            players: [],
            interactedWith: []
        },
        youtube: {
            iframes: [],
            players: [],
            interactedWith: [],
            action: function(iframe, vidFunc) {
                iframe.contentWindow.postMessage(`{"event":"command","func":"${vidFunc}","args":""}`,"*"
                );
            }
        },
        haveInteracted: false,
        iframe: jQuery('.js-eldorado-video-modal').find('iframe')[0],
        player: null,
        init: function(){
            jQuery('.js-eldorado-video-modal[data-provider="vimeo"]').each(function ( intIndex, domElement){
                e4.product.video.vimeo.iframes.push(jQuery(domElement).find('iframe')[0]);
                e4.product.video.vimeo.interactedWith.push(false);
            });
            jQuery('.js-eldorado-video-modal[data-provider="youtube"]').each(function ( intIndex, domElement){
                e4.product.video.youtube.iframes.push(jQuery(domElement).find('iframe')[0]);
                e4.product.video.youtube.interactedWith.push(false);
            });
            e4.product.video.bindEvents();
        },
        bindEvents: function(){
            jQuery.each(e4.product.video.vimeo.iframes, function ( intIndex, objIframe ) {
                e4.product.video.vimeo.players.push(new Vimeo.Player( objIframe ));
                e4.product.video.vimeo.players[intIndex].on('play', function (){
                    e4.product.video.vimeo.interactedWith[intIndex] = true;
                });
            });

            jQuery( '.js-eldorado-video-modal[data-provider="vimeo"]' ).on( 'shown.bs.modal', function ( event ) {
                const intIndex = jQuery( '.js-eldorado-video-modal[data-provider="vimeo"]' ).index( event.currentTarget );
                if ( e4.product.video.vimeo.interactedWith[intIndex] ){
                    e4.product.video.vimeo.players[intIndex].play();
                }
            } )
            .on( 'hide.bs.modal', function ( event ) {
                const intIndex = jQuery( '.js-eldorado-video-modal[data-provider="vimeo"]' ).index( event.currentTarget );
                e4.product.video.vimeo.players[intIndex].pause();
            } );

            jQuery( '.js-eldorado-video-modal[data-provider="youtube"]' ).on( 'shown.bs.modal', function ( event ) {
                const intIndex = jQuery( '.js-eldorado-video-modal[data-provider="youtube"]' ).index( event.currentTarget );
                e4.product.video.youtube.action(e4.product.video.youtube.iframes[intIndex], 'playVideo');
            } )
            .on( 'hide.bs.modal', function ( event ) {
                const intIndex = jQuery( '.js-eldorado-video-modal[data-provider="youtube"]' ).index( event.currentTarget );
                e4.product.video.youtube.action(e4.product.video.youtube.iframes[intIndex], 'pauseVideo');
            } );
        }
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm ); //jQuery( '.js-e-product' ).find( domForm );
        
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    }
};
